export function generateBundleSerial(): string {
  const timestamp = Date.now();
  const randomStr = Math.floor(Math.random() * 36 ** 5)
    .toString(36)
    .toUpperCase()
    .padStart(5, '0');

  return `BDL-${timestamp}${randomStr}`;
}
